import { useState } from "react";
import { motion } from "framer-motion";
import SectionHeading from "./SectionHeading";
import SocialLinks from "./SocialLinks";
import { CONTACT } from "../data/siteContent";

export default function Contact() {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <section id="contact" className="relative bg-ink-soft py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Contact"
          title="Let's build something"
          titleAccent="exceptional"
          subtitle="Tell us about your brand, timeline, and goals — we'll respond within one business day."
        />
        <div className="grid gap-12 lg:grid-cols-2">
          <motion.form
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            onSubmit={handleSubmit}
            className="space-y-5 rounded-3xl border border-white/10 bg-ink-card p-8 shadow-card"
          >
            {sent ? (
              <p className="py-12 text-center text-lg text-accent-light">
                Thank you — we&apos;ll be in touch shortly.
              </p>
            ) : (
              <>
                <div className="grid gap-5 sm:grid-cols-2">
                  <input
                    required
                    placeholder="Your name"
                    className="rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-white placeholder:text-white/40 focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
                  />
                  <input
                    type="email"
                    required
                    placeholder="Email address"
                    className="rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-white placeholder:text-white/40 focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
                  />
                </div>
                <div className="grid gap-5 sm:grid-cols-2">
                  <input
                    placeholder="Company"
                    className="rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-white placeholder:text-white/40 focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
                  />
                  <input
                    type="tel"
                    name="phone"
                    autoComplete="tel"
                    placeholder="Phone number"
                    className="rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-white placeholder:text-white/40 focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
                  />
                </div>
                <textarea
                  required
                  rows={5}
                  placeholder="Project details"
                  className="w-full resize-none rounded-xl border border-white/10 bg-white/5 px-4 py-3.5 text-white placeholder:text-white/40 focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
                />
                <button
                  type="submit"
                  className="w-full rounded-full bg-gradient-to-r from-accent to-indigo-500 py-4 text-sm font-bold uppercase tracking-wider text-white shadow-glow transition hover:brightness-110"
                >
                  Send Message
                </button>
              </>
            )}
          </motion.form>

          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="space-y-6">
              {[
                { label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
                { label: "Phone", value: CONTACT.phone, href: `tel:${CONTACT.phone.replace(/\s/g, "")}` },
                { label: "Location", value: CONTACT.address },
              ].map((row) => (
                <div key={row.label} className="rounded-2xl border border-white/10 bg-white/[0.03] p-5">
                  <p className="text-xs font-semibold uppercase tracking-wider text-accent-light">{row.label}</p>
                  {row.href ? (
                    <a href={row.href} className="mt-2 block text-white/80 transition hover:text-white">
                      {row.value}
                    </a>
                  ) : (
                    <p className="mt-2 text-white/80">{row.value}</p>
                  )}
                </div>
              ))}
            </div>
            <SocialLinks />
            <div className="overflow-hidden rounded-2xl border border-white/10">
              <div className="flex aspect-video items-center justify-center bg-ink-card px-4 text-center text-sm text-white/40">
                {CONTACT.address}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
